import { Container, Grid, Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useCallback } from 'react'
import StatusIcon from './subcomponents/StatusIcon'
import styles from 'modules/Tickets/List/subcomponents/Row/row.module.scss'
import { parse } from 'date-fns'
import format from 'utils/dateFns/format'
import { useTranslation } from 'react-i18next'
import { notificationShow } from 'modules/Notifications/actions'
import useWriteToClipboard from 'utils/hooks/useWriteToClipboard'
import { useDispatch } from 'react-redux'

export const RowItem = ({
  id,
  title = '',
  status = '',
  updated_at = '',
  unread_count,
  last_message = null,
  openTicket,
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const writeToClipboard = useWriteToClipboard()

  const toClipboard = useCallback((value) => {
    writeToClipboard(value)

    dispatch(
      notificationShow({
        type: 'success',
        message: 'common::notifications.success_copy_notification',
      }),
    )
  }, [])

  return (
    <Grid
      className={styles['ticket-row']}
      direction={'column'}
      gap={16}
      onClick={() => openTicket(id)}
    >
      <Grid
        gap={16}
        alignItems={'flex-start'}
        wrap={'nowrap'}
      >
        <Container display={'flex'}>
          <StatusIcon
            status={status}
            counter={unread_count}
          />
        </Container>
        <Grid
          gap={4}
          direction={'column'}
        >
          <Grid className={styles['ticket-row__title-wrapper']}>
            <Typography
              component={'div'}
              className={styles['ticket-row__title']}
              variant={'Body-20'}
              noMargin
              color={/*unread_count > 0 ?*/ 'Label-Fifth' /*: 'Label-Secondary'*/}
            >
              {title}
            </Typography>
          </Grid>
          <Grid
            gap={16}
            alignItems={'center'}
            direction={'row'}
          >
            <Typography
              component={'span'}
              variant={'Body-10'}
              noMargin
              color={'Label-Fifth'}
              className={styles['ticket-row__id']}
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                toClipboard(`#${id}`)
              }}
            >
              #{id}{' '}
            </Typography>
            <Typography
              component={'span'}
              variant={'Body-10'}
              noMargin
              color={'Label-Secondary'}
            >
              {t('common::updated_at')}{' '}
              {format(
                parse(updated_at, "yyyy-MM-dd'T'HH:mm:ssXXX", new Date()),
                'HH:mm, d.MM.yyyy',
              )}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      {last_message?.text && (
        <Typography
          variant={'Body-15'}
          noMargin
          color={'Label-Secondary'}
          className={styles['ticket-row__last-message']}
          dangerouslySetInnerHTML={{
            __html: `${last_message.text.substring(0, 250)}${
              last_message.text.length > 250 ? '…' : ''
            }`,
          }}
        />
      )}
    </Grid>
  )
}

RowItem.propTypes = {
  id: PropTypes.number,
  unread_count: PropTypes.number,
  status: PropTypes.oneOf(['opened', 'pending', 'working', 'closed']),
  title: PropTypes.string,
  updated_at: PropTypes.string,
  last_message: PropTypes.object,
  openTicket: PropTypes.func,
}

export default RowItem
